import { CopyOutlined } from '@ant-design/icons';
import { Button, Card, Input, Space, Typography } from 'antd';
import React, { useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';

const { Text, Title, Paragraph } = Typography;

const Web: React.FC = () => {

    const [titleValue, setTitleValue] = useState<string>('');
    const [descriptionValue, setDescriptionValue] = useState<string>('');
    const [textCounterValue, setTextCounterValue] = useState<string>('');

    const [titleTips, setTitleTips] = useState<React.ReactNode>('');
    const [descriptionTips, setDescriptionTips] = useState<React.ReactNode>('');
    const [textCounterTips, setTextCounterTips] = useState<React.ReactNode>('');

    const onChangeTitle = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const value = e.target.value;
        var _length = value.replace(/{.*}/g, "").length;
        setTitleValue(value)
        if (_length === 0) {
            setTitleTips(<></>);
        } else if (_length < 25) {
            const render = (<>
                <Text>{`Characters: ${_length}/65  recommended maximum`}</Text>
                <Text>{`characters is too short. We recommend a minimum of 25 characters.`}</Text>
            </>)
            setTitleTips(render);
        } else if (_length >= 25 && _length < 65) {
            const render = (<>
                <Text type="success">{`Characters: ${_length}/65  recommended maximum`}</Text>
            </>)
            setTitleTips(render);
        } else {
            const render = (<>
                <Text type="danger">{`Characters: ${_length}/65  recommended maximum`}</Text>
                <Text type="danger">{`We recommend a maximum of 65 characters.`}</Text>
            </>)
            setTitleTips(render);
        }
    };

    const onChangeDescription = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const value = e.target.value;
        setDescriptionValue(value);
        var _length = value.replace(/{.*}/g, "").length;
        if (_length === 0) {
            setDescriptionTips(<></>);
        } else if (_length < 100) {
            const render = (<>
                <Text>{`Characters: ${_length}/155  recommended maximum`}</Text>
                <Text>{`characters is too short. We recommend a minimum of 100 characters.`}</Text>
            </>)
            setDescriptionTips(render);
        } else if (_length >= 100 && _length <= 155) {
            const render = (<>
                <Text type="success">{`Characters: ${_length}/155  recommended maximum`}</Text>
            </>)
            setDescriptionTips(render);
        } else {
            const render = (<>
                <Text type="danger">{`Characters: ${_length}/155  recommended maximum`}</Text>
                <Text type="danger">{`We recommend a maximum of 155 characters.`}</Text>
            </>)
            setDescriptionTips(render);
        }
    };

    const onChangeCounter = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const value = e.target.value;
        setTextCounterValue(value);
        var _length = value.replace(/{.*}/g, "").length;
        if (_length === 0) {
            setTextCounterTips(<></>);
        } else {
            const render = (<>
                <Text>{`Characters: ${_length}`}</Text>
            </>)
            setTextCounterTips(render);
        }
    };

    return (
        <>
            <Title level={2}>Title Tag and Meta Description Length Tools</Title>
            <Text >Useful tools for checking the length of meta titles and descriptions, as well as a quick character counter.</Text>

            <Card title="Meta Title Length Checker - <title> Tag" bordered={false} style={{ width: 'auto' }}>
                <Space direction="vertical" size={'small'}>
                    <Text>Enter your meta title here to check if it is between 50 - 65 characters long to keep it in accordance with Google's maximum title length threshold.</Text>
                    <Input.TextArea placeholder='<title> tag'
                        style={{ height: 60, resize: 'none' }}
                        showCount
                        count={{
                            show: true,
                            max: 65,
                        }}
                        onChange={onChangeTitle}
                    />
                    {titleTips}
                    <CopyToClipboard text={titleValue}>
                        <Button icon={<CopyOutlined />}>Copy to clipboard</Button>
                    </CopyToClipboard>
                </Space>
            </Card>

            <Card title="Meta Description Length Checker" bordered={false} style={{ width: 'auto' }}>
                <Space direction="vertical" size={'small'}>
                    <Text>Keep meta descriptions around the recommended length of 155 characters, otherwise they will be truncated when they show up in search results.</Text>
                    <Input.TextArea placeholder='meta description'
                        style={{ height: 60, resize: 'none' }}
                        showCount
                        count={{
                            show: true,
                            max: 155,
                        }}
                        onChange={onChangeDescription}
                    />
                    {descriptionTips}
                    <CopyToClipboard text={descriptionValue}>
                        <Button icon={<CopyOutlined />}>Copy to clipboard</Button>
                    </CopyToClipboard>
                </Space>
            </Card>

            <Card title="Quick Text Counter" bordered={false} style={{ width: 'auto' }}>
                <Space direction="vertical" size={'small'}>
                    <Text>Paste any text here to quickly count the amount of characters.</Text>
                    <Input.TextArea placeholder='paste text here'
                        style={{ height: 60, resize: 'none' }}
                        showCount
                        onChange={onChangeCounter}
                    />
                    {textCounterTips}
                    <CopyToClipboard text={textCounterValue}>
                        <Button icon={<CopyOutlined />}>Copy to clipboard</Button>
                    </CopyToClipboard>
                </Space >
            </Card>

        </>
    );
};

export default Web;